import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const NotificationItemFooterDefinitionStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "notification-item-footer-definition",
  },
)`
  color: ${rydeColors.grey};
  display: inline-block;

  & + & {
    &:before {
      content: "|";
      margin: 0 10px;
    }
  }
`;
